import { Component, Input } from '@angular/core';
import { DeviceReducedDashboardCardComponent } from '../../../devices/components/device-reduced-dashboard-card/device-reduced-dashboard-card.component';
import { ApiDeviceResponseDto } from '@birco/rainmesh-api';
import { AsyncPipe } from '@angular/common';
import { Observable, of } from 'rxjs';
import { MatTabGroup, MatTab } from '@angular/material/tabs';

@Component({
  selector: 'app-device-values-dashboard-card',
  imports: [
    DeviceReducedDashboardCardComponent,
    AsyncPipe,
    //MatTabGroup, MatTab
  ],
  templateUrl: './device-values-dashboard-card.component.html',
  styleUrl: './device-values-dashboard-card.component.scss',
})
export class DeviceValuesDashboardCardComponent {
  @Input() soilDeviceList$: Observable<ApiDeviceResponseDto[]> = of([]);
  @Input() flowDeviceList$: Observable<ApiDeviceResponseDto[]> = of([]);
}
